module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.item.shouldNotChangeRoute) ? _c('li', {
    class: _vm.itemClasses,
    attrs: {
      "data-action": _vm.item.action
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.allowedAccess) ? _c('div', {
    staticClass: "clickable",
    attrs: {
      "to": {
        name: _vm.item.name
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.item.icon))]) : _vm._e(), _vm._v(" "), (this.item.label) ? _c('div', [_vm._v(_vm._s(this.item.label) + " ")]) : (this.item.title) ? _c('div', [_vm._v(_vm._s(this.item.title) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.$t(("ui.menu." + (_vm.item.name)))))])]) : _c('navigation-locked-item', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _c('span', {
    class: _vm.itemClasses,
    attrs: {
      "data-action": _vm.item.action
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.allowedAccess) ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.item.name
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.item.icon))]) : _vm._e(), _vm._v(" "), (this.item.title) ? _c('div', [_vm._v(_vm._s(this.item.title) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.$t(("ui.menu." + (_vm.item.name)))))])]) : _c('navigation-locked-item', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b613a6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/FoldedNavigationItem.vue
// module id = 1969
// module chunks = 0